import { TOKENIZATION_WIDGET_DEFAULT_SIZE } from "./tokenization-widget-size";

/** Maps shared `"desktop"` preset to tokenization's larger default when used as a preset value. */
export function applyTokenizationDesktopWidth<T extends { width: number }>(
  widthValue: string | number | undefined,
  resolved: T,
): T {
  if (widthValue === "desktop") {
    return { ...resolved, width: TOKENIZATION_WIDGET_DEFAULT_SIZE.width };
  }
  return resolved;
}

/** Maps shared `"desktop"` preset to tokenization's larger default when used as a preset value. */
export function applyTokenizationDesktopHeight<T extends { height: number }>(
  heightValue: string | number | undefined,
  resolved: T,
): T {
  if (heightValue === "desktop") {
    return { ...resolved, height: TOKENIZATION_WIDGET_DEFAULT_SIZE.height };
  }
  return resolved;
}
